import React from 'react';


const BoldStepsList = ({ stepsList }) => (
  <ul className="m-5">
    {stepsList.map((step, idx) => (
      <li className="font-semibold" key={idx}>{step}</li>
    ))}
  </ul>
);

export default BoldStepsList;
